import { nanoid } from 'nanoid';
import React, { ChangeEventHandler, useEffect, useState } from 'react';
import { FieldHookConfig, useField } from 'formik';
import { useTranslation } from 'react-i18next';

export function TemplateImgField({
  title,
  imageUrl,
  ...props
}: {
  title: string;
  imageUrl: string;
} & FieldHookConfig<File | null>) {
  const [t] = useTranslation(['common']);
  const fileFieldId = nanoid();
  const [imgSrc, setImgSrc] = useState<string>(imageUrl);
  const [field, , helpers] = useField(props);

  useEffect(() => {
    const file = field.value;
    if (file) {
      const src = URL.createObjectURL(file);
      setImgSrc(src);
      return;
    }
    setImgSrc(imageUrl);
  }, [field.value, imageUrl]);

  const onFileSelect: ChangeEventHandler<HTMLInputElement> = (e) => {
    const files = e.target.files;
    if (files && files[0]) {
      helpers.setValue(files[0]);
      return;
    }

    helpers.setValue(null);
  };

  return (
    <div className="flex my-8 gap-8">
      {imgSrc ? <img alt="" className="h-48 rounded" src={imgSrc} /> : <></>}
      <div className="flex flex-col justify-center gap-3 overflow-clip">
        <span className="text-[#53586C]">{title}</span>
        <label
          htmlFor={fileFieldId}
          className="cursor-pointer text-group-primary border border-group-primary rounded flex justify-center items-center text-sm px-6 font-normal h-[48px] w-fit"
        >
          {t('choose_file', '選擇檔案')}
        </label>
        <input
          id={fileFieldId}
          accept="image/*"
          type="file"
          className="hidden"
          onChange={onFileSelect}
        />

        <div className="overflow-scroll">
          <span className="text-sm font-light whitespace-nowrap">
            {field.value
              ? field.value.name
              : t('no_file_chosen', '未選擇任何檔案')}
          </span>
        </div>
      </div>
    </div>
  );
}
